module.exports = __webpack_public_path__ + "static/media/access-slim.c48f1717.svg";